export default "__VITE_ASSET__rb7t_FIc__"